import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HttpErrorProps } from '../../../../hooks/useHttpError';
import { ReactComponent as HttpErrorIllustration } from '../../../../assets/illustrations/globaleris-error-http.svg';
import { styles } from './apiError.styles';

export interface ApiErrorProps extends HttpErrorProps {
  onRefresh?: () => void;
  onReportError?: () => void;
}

export const ApiError: React.FC<ApiErrorProps> = ({ onRefresh, onReportError }) => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();
  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <HttpErrorIllustration className={classes.errorImage} aria-label={t('httpErrors:api.title')} />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:api.title')}</h1>
        <p>
          {t('httpErrors:api.subtitle')}
          <br />
          {t('httpErrors:api.text')}
        </p>
        {onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              onRefresh && onRefresh();
            }}
          >
            {t('httpErrors:api.actions.refresh')}
          </Button>
        )}
        {onReportError && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              onReportError && onReportError();
            }}
          >
            {t('httpErrors:api.actions.report')}
          </Button>
        )}
      </div>
    </div>
  );
};
